import React, { useEffect, useState } from 'react';
import './changePassword.css';
import { getSystem, updateSystem } from '../../../api/system';
import LoadingPage from '../../Loading/loading';

const System = () => {
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getSystem().then((result) => {
            setFormData(result.data.response)
        })
    }, [])

    const handleChange = (e) => {
        e.target.setCustomValidity("")
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        updateSystem(formData).then((result) => {
            setLoading(false);
        })
    };

    return (
        <>{formData === null ? <LoadingPage /> : <div className="add-brokers-guideline">
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="active_users">Active users</label>
                    <input
                        type='number'
                        id="usersTotal"
                        name="usersTotal"
                        value={formData.usersTotal}
                        onChange={handleChange}
                        placeholder="Enter active users"
                        required
                        onInvalid={(e) => e.target.setCustomValidity("Active users is required")}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="forms">Sales</label>
                    <input
                        type='number'
                        id="sales"
                        name="sales"
                        value={formData.sales}
                        onChange={handleChange}
                        placeholder="Enter sales"
                        required
                        onInvalid={(e) => e.target.setCustomValidity("sales is required")}
                    />
                </div>

                {loading ? <div style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex"
                }}>
                    <div className="spinner"></div>
                </div> : <button type="submit" className="submit-button">
                    Update system
                </button>}
            </form>
        </div>}</>
    );
};

export default System;